export default function getHeaderHeight(header) {
  const { height } = header.getBoundingClientRect();
  return Math.ceil(height);
}
